import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

/**
 * Generated class for the SelectMitarbeiterPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-mitarbeiter',
  templateUrl: 'select-mitarbeiter.html',
})
export class SelectMitarbeiterPage {
Mitarbeiter = [];
loading: any;
mode = {create:true};

  constructor(public navCtrl: NavController, 
  private rhynoApi: RhynoApiProvider,
	public navParams: NavParams,
  public loadingCtrl: LoadingController,
	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;

  	this.getData();

  }

  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getMitarbeiter().subscribe(
      data => {
      if (data.success){
        this.Mitarbeiter = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Mitarbeiter Search Complete')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectMitarbeiterPage');
  }
  select(data){

    if (this.mode.create == true ){
    	this.leistungCtrl.leistung.Mitarbeiter = data.Nr;
    	this.leistungCtrl.leistung.MitarbeiterName = data.Vorname;
    	this.leistungCtrl.leistung.Kostentraeger = data.FreierText1; //Kostenträger
    }else{
      this.leistungCtrl.leistungEdit.Mitarbeiter = data.Nr;
      this.leistungCtrl.leistungEdit.MitarbeiterName = data.Vorname;
      this.leistungCtrl.leistungEdit.Kostentraeger = data.FreierText1; //Kostenträger
    }
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-mitarbeiter/select-mitarbeiter.ts